import { render, staticRenderFns } from "./Suggestions.vue?vue&type=template&id=d1d48e70&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=ts"
export * from "./Suggestions.vue?vue&type=script&lang=ts"
import style0 from "./Suggestions.vue?vue&type=style&index=0&id=d1d48e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d48e70",
  null
  
)

export default component.exports